module.exports = __webpack_public_path__ + "img/alert-pop-memo-enter.7fa32d41.svg";